import { render, staticRenderFns } from "./KqtHistoryList.vue?vue&type=template&id=681a0608&scoped=true"
import script from "./KqtHistoryList.vue?vue&type=script&lang=js"
export * from "./KqtHistoryList.vue?vue&type=script&lang=js"
import style0 from "./KqtHistoryList.vue?vue&type=style&index=0&id=681a0608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a0608",
  null
  
)

export default component.exports